import { Box, Button, Card, Title } from '@nimbus-ds/components';
import { useModal } from 'commons/hooks';
import { trackingThemeLayoutChange } from 'domains/Online/Themes/tracking';
import useTranslationOnline from 'domains/Online/useTranslationOnline';
import ImageSrc from './images/not_theme_draft.png';
import { NewDraftModal } from './NewDraftModal';
import { useGoToThemesStore } from '../../hooks';
import './DraftCard.scss';

export function DraftAd() {
  const t = useTranslationOnline('themesPage.draft');
  const [showModal, closeModal] = useModal();

  const handleGoToThemesStore = useGoToThemesStore();

  const handleClickTryNewDesign = async () => {
    trackingThemeLayoutChange();
    await handleGoToThemesStore();
  };

  const actionLabel202411 = t('switchDraft-202411');
  const actionTitle202411 = t('title-202411');

  return (
    <>
      <Card padding="none">
        <Card.Header>
          <div className="draft-card-img-container">
            <img className="draft-card-img" alt="image" src={ImageSrc} />
          </div>
        </Card.Header>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          paddingBottom="4"
          paddingLeft="4"
          paddingRight="4"
          gap="2"
          alignItems={{ md: 'center', xs: 'flex-start' }}
          justifyContent="space-between"
        >
          <Title as="h4">{actionTitle202411}</Title>
          <Button appearance="neutral" onClick={handleClickTryNewDesign}>
            {actionLabel202411}
          </Button>
        </Box>
      </Card>
      <NewDraftModal showModal={showModal} onClose={closeModal} />
    </>
  );
}
